import { webCoreTypes } from "@core/core-types.di";
import { FallbackError } from "@core/domain/errors/fallback.error";
import type { IotApiClient } from "@iot-platform/core";
import type { SensorGroupsDto } from "@station/data/dto/sensor-group.dto";
import { SensorGroupMapper } from "@station/data/mappers/sensor-group.mapper";
import type { SensorGroups } from "@station/domain/models/sensor-group.model";
import { inject, injectable } from "inversify";
import type { ResultAsync } from "neverthrow";

@injectable()
export class SensorGroupDatasource {
    static readonly VARIABLE_PATH = "/stations/:stationId/var_groups";

    constructor(
        @inject(webCoreTypes.infrastructure.IotApiClient)
        private readonly iotApiClient: IotApiClient,
        @inject(SensorGroupMapper)
        private readonly sensorGroupMapper: SensorGroupMapper,
    ) {}

    fetchAll(stationId: string): ResultAsync<SensorGroups, FallbackError> {
        return this.iotApiClient.http
            .get<SensorGroupsDto>(
                SensorGroupDatasource.VARIABLE_PATH.replace(
                    ":stationId",
                    stationId,
                ),
            )
            .mapErr(() => new FallbackError())
            .map((response) => this.sensorGroupMapper.mapList(response.data));
    }
}
